// Do not edit
export default "https://gn80ai4ca2.execute-api.us-east-1.amazonaws.com/prod/";
